import React, {Component} from 'react';
import styled from 'styled-components';
import {Button, SectionTitle} from '../Kit/Kit';
import InputField from "../InputField/InputField";


const Container = styled.div`
  padding: 32px 16px 50px;
  display: grid;
  grid-row-gap: 16px;
  position: relative;
  
  @media(min-width: 768px) {
    padding: 0 100px;
    grid-row-gap: 24px;
  }
  
  @media(min-width: 992px) {
    padding: 0 200px;
  }
  
  @media(min-width: 1200px) {
    padding: 0 250px;
  }
  
  @media(min-width: 1680px) {
    padding: 0 400px;
  }
`;

const StyledTitle = SectionTitle.extend`
  z-index: 1;
`;

const Form = styled.form`
  display: grid;
  grid-row-gap: 12px;
  grid-template-columns: 1fr;
  z-index: 1;
  
  button {
    justify-self: center;
  }
`;

const encode = (data) => {
    return Object.keys(data)
      .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
      .join("&");
};

class ContactForm extends Component {
    state = {
        name: '',
        email: '',
        message: ''
    };

    handleOnChange = (event) => {
        const {name, value} = event.currentTarget;
        this.setState(() => ({[name]: value}));
    };

    handleSubmit = (event) => {
        fetch("/", {
            method: "POST",
            headers: {"Content-Type": "application/x-www-form-urlencoded"},
            body: encode({"form-name": "contact", ...this.state})
        }).then(() => alert("Message successfully sent!"))
          .catch(error => alert(error));
        event.preventDefault();
    };

    render() {
        const {name, email, message} = this.state;
        return (
          <Container>
					{/*
              <StyledTitle>Send us a Message</StyledTitle>
              <Form
                data-netlify="true"
                data-netlify-honeypot="bot-field"
                onSubmit={this.handleSubmit}
                name="contact"
                method="post"
              >
                  <InputField
                    name="name"
                    value={name}
                    type="text"
                    onChange={this.handleOnChange}
                    placeholder="Name"
                    required
                  />
                  <InputField
                    name="email"
                    value={email}
                    type="email"
                    onChange={this.handleOnChange}
                    placeholder="Name@email.com"
                    required
                  />
                  <InputField
                    name="message"
                    value={message}
                    type="textarea"
                    onChange={this.handleOnChange}
                    placeholder="Your Message"
                    required
                  />
                  <Button>Send</Button>
              </Form>
							*/}
          </Container>
        );
    }
}

export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/Connect/ContactForm.js